import React from 'react';
import { number, bool } from 'prop-types';

import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import AdvancedRow from 'ps-components/AdvancedTable/AdvancedRow';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';

import { overallComposite } from '../../propTypes';
import { getDisplayValue, getYoYChange } from './helpers';

import './PayElementAtTargetTable.scss';

const labelMapping = {
  baseSalary: 'Base Salary',
  totalCash: 'Total Cash',
  totalTargetCash: 'Total Target Cash',
  totalDirect: 'Total Direct',
  totalGuaranteedPay: 'Total Guaranteed Pay',
  totalEmployeeCount: 'Total Employee Count',
  totalCompanyCount: 'Total Company Count'
};

class PayElementsAtTargetTable extends React.Component {
  static propTypes = {
    data: overallComposite,
    monetaryRounding: number,
    percentRounding: number,
    showOverallComposites: bool
  };

  getTableColumns(data) {
    const { baseSalary } = data;
    const { prevPrevYear, prevYear, currentYear } = baseSalary;

    return [
      'Pay Element at Target',
      'Target',
      prevPrevYear.label,
      prevYear.label,
      currentYear.label,
      `${prevPrevYear.label} - ${prevYear.label}`,
      `${prevYear.label} - ${currentYear.label}`
    ];
  }

  getPayElementRowData(element, elementData) {
    const { monetaryRounding, percentRounding } = this.props;
    const label = labelMapping[element];
    const { targetElement, prevPrevYear, prevYear, currentYear } = elementData;
    const isSJMCount = element === 'totalEmployeeCount' || element === 'totalCompanyCount';
    return [
      <span key={`${label}-0`} className="pay-elements-table__header-cell">
        {label}
      </span>,
      isSJMCount ? null : targetElement,
      getDisplayValue(prevPrevYear.value, monetaryRounding),
      getDisplayValue(prevYear.value, monetaryRounding),
      getDisplayValue(currentYear.value, monetaryRounding),
      getYoYChange(prevPrevYear.value, prevYear.value, percentRounding),
      getYoYChange(prevYear.value, currentYear.value, percentRounding)
    ];
  }

  getTableRows(rowData, rowIndex) {
    const cells = rowData.map((cell, cellIndex) => {
      return (
        <AdvancedCell className="pxl-text-xsmall pay-elements-table__cell" key={cellIndex}>
          {cell}
        </AdvancedCell>
      );
    });

    return <AdvancedRow key={`salary-${rowIndex}`}>{cells}</AdvancedRow>;
  }

  render() {
    const { data, showOverallComposites } = this.props;

    const rows = showOverallComposites
      ? [
          this.getPayElementRowData('baseSalary', data.baseSalary),
          this.getPayElementRowData('totalCash', data.totalCash),
          this.getPayElementRowData('totalTargetCash', data.totalTargetCash),
          this.getPayElementRowData('totalDirect', data.totalDirect),
          this.getPayElementRowData('totalGuaranteedPay', data.totalGuaranteedPay)
        ]
      : [
          this.getPayElementRowData('baseSalary', data.baseSalary),
          this.getPayElementRowData('totalCash', data.totalCash),
          this.getPayElementRowData('totalTargetCash', data.totalTargetCash),
          this.getPayElementRowData('totalDirect', data.totalDirect),
          this.getPayElementRowData('totalGuaranteedPay', data.totalGuaranteedPay),
          this.getPayElementRowData('totalEmployeeCount', data.totalEmployeeCount),
          this.getPayElementRowData('totalCompanyCount', data.totalCompanyCount)
        ];

    return (
      <AdvancedTable
        staticTable={true}
        columnHeaders={this.getTableColumns(data)}
        rowData={rows}
        getDataRow={this.getTableRows}
        className="pay-elements-table"
        headerClassName="pay-elements-table__header"
        bodyClassName="pay-elements-table__tbody"
      />
    );
  }
}

export default PayElementsAtTargetTable;
